/*
 * VIP page helpers
 * - Native copy-to-clipboard for VIP offer codes.
 * - Resets horizontal offer tracks on load/pageshow so browser refresh/back states do not leave the page horizontally offset.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function fallbackCopy(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    input.style.top = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
    } catch (error) {}
    document.body.removeChild(input);
    return Promise.resolve();
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopy(text);
      });
    }
    return fallbackCopy(text);
  }

  function showCopied(button) {
    var targetId = button.getAttribute('data-copy-target');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;
    target.classList.add('copied');
    window.setTimeout(function () {
      target.classList.remove('copied');
    }, 1200);
  }

  function handleCopy(event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('[data-vip-copy]');
    if (!button) return;

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();

    var text = button.getAttribute('data-copy-text') || button.textContent || '';
    text = text.trim();
    if (!text) return;

    copyText(text).then(function () {
      showCopied(button);
    });
  }

  function resetVipTracks(scope) {
    var root = scope || document;
    var tracks = root.querySelectorAll ? root.querySelectorAll('[data-vip-scroll-track]') : [];
    tracks.forEach(function (track) {
      track.scrollLeft = 0;
    });
  }

  ready(function () {
    document.addEventListener('click', handleCopy, false);
    document.addEventListener('keydown', handleCopy, false);
    resetVipTracks(document);

    window.addEventListener('pageshow', function () {
      resetVipTracks(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      resetVipTracks(event.target);
    });
  });
})();
